import {isMobile} from '@netx/core-next/utils/browser';
import {currentUserHasAssetAttributeAccess} from '@netx/core-permissions-next/enablers';

export const canUseGridEditor = (): boolean =>
	!isMobile() && currentUserHasAssetAttributeAccess();
